/**
 * @generated SignedSource<<cc31bc4ee16b50ddccb0e7e69a5e3726>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type GuildMembershipStatus = "ACTIVE" | "DENIED" | "PENDING" | "%future added value";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GuildCardNew_guild$data = {
  readonly backgroundPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly defaultBackgroundUrl: string;
  readonly description: string | null | undefined;
  readonly isPrivate: boolean;
  readonly memberCount: number;
  readonly myMembership: {
    readonly membershipLevel: GuildMembershipLevel;
    readonly status: GuildMembershipStatus;
  } | null | undefined;
  readonly name: string;
  readonly rowId: string;
  readonly slugId: string;
  readonly type: GuildTypes | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild" | "GuildSocialProfileLinks_guild">;
  readonly " $fragmentType": "GuildCardNew_guild";
};
export type GuildCardNew_guild$key = {
  readonly " $data"?: GuildCardNew_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildCardNew_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildCardNew_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GuildSocialProfileLinks_guild"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildMembership",
      "kind": "LinkedField",
      "name": "myMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "membershipLevel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GuildPrimaryPhotoNew_guild"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "fit": "cover",
                "h": 200,
                "w": 500
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":200,\"w\":500})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "h": 200,
            "w": 500
          }
        }
      ],
      "kind": "ScalarField",
      "name": "defaultBackgroundUrl",
      "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":3,\"h\":200,\"w\":500})"
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "008ea4b0676725a8114a66b74b2020cf";

export default node;
